import { WobGbdType } from '@/enum/WobGbdType'
import { ConsoleRow } from './ConsoleRow'

export class MissionUiState {
  public typeUiid: string
  public timelineIndex: number
  public rangeTimelineIndex: [number, number]
  public sciHoverData: any
  public navHoverData: any
  public simuHoverData: any
  public mapStyles: any
  public canLogConsoleMsg: boolean
  public consoleMsgsLoading: boolean
  public consoleMsgs: Array<ConsoleRow>
  public consoleGdbFilter: Array<string>
  public consoleAutoScroll: boolean
  public consoleScrollIndex: number | boolean
  public refreshSciGraphCache: boolean
  public importedCsvHeaders: Array<string> | null
  public refreshNavGraphCache: boolean
  public infosPanelVisible: boolean
  public showPath: boolean
  public showMoreNmea: boolean
  public showRemainingNavigation: boolean

  constructor({
    typeUiid = 'detail', //detail ou global ou fleet
    timelineIndex = -1,
    rangeTimelineIndex = [-1, -1] as [number, number],
    sciHoverData = null,
    navHoverData = null,
    simuHoverData = null,
    mapStyles = {},
    canLogConsoleMsg = false,
    consoleMsgsLoading = false,
    consoleMsgs = [] as Array<ConsoleRow>,
    consoleAutoScroll = true,
    consoleScrollIndex = false,
    consoleGdbFilter = [
      WobGbdType.GliderInfoModConf,
      WobGbdType.GliderInfoModEvent,
      WobGbdType.GliderInfoTarget,
    ] as Array<string>,
    refreshSciGraphCache = false,
    importedCsvHeaders = [],
    refreshNavGraphCache = false,
    infosPanelVisible = false,
    showPath = true,
    showMoreNmea = false,
    showRemainingNavigation = false,
  } = {}) {
    this.typeUiid = typeUiid
    this.timelineIndex = timelineIndex
    this.rangeTimelineIndex = rangeTimelineIndex
    this.sciHoverData = sciHoverData
    this.navHoverData = navHoverData
    this.simuHoverData = simuHoverData
    this.mapStyles = mapStyles
    this.consoleMsgsLoading = consoleMsgsLoading
    this.canLogConsoleMsg = canLogConsoleMsg
    this.consoleAutoScroll = consoleAutoScroll
    this.consoleScrollIndex = consoleScrollIndex
    this.consoleMsgs = consoleMsgs
    this.consoleGdbFilter = consoleGdbFilter
    this.refreshSciGraphCache = refreshSciGraphCache
    this.importedCsvHeaders = importedCsvHeaders
    this.refreshNavGraphCache = refreshNavGraphCache
    this.infosPanelVisible = infosPanelVisible
    this.showPath = showPath
    this.showMoreNmea = showMoreNmea
    this.showRemainingNavigation = showRemainingNavigation
  }
}

export const buildMissionUIStateId = (missionId: number, typeuiid: string) => {
  return `mission_${missionId}_${typeuiid}`
}
